import { useBreakPoint } from '@/hooks/useBreakPoint';
import { useWindowStore } from '@/stores/useWindowStore';
import { useEffect } from 'react';
import { Platform, useWindowDimensions } from 'react-native';

export const useWindowDetector = () => {
    
    const breakPointData = useBreakPoint();
    const dimensions = useWindowDimensions();
    const setWindowData = useWindowStore((s) => s.setWindowData);

    useEffect(() => {

        const isNative = Platform.OS === 'ios' || Platform.OS === 'android';
        const isWeb = Platform.OS === 'web';

        let hasHover = false;
        let hasFinePointer = false;
        let hasCoarsePointer = false;

        if (isWeb && typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
            hasHover = window.matchMedia('(hover: hover)').matches;
            hasFinePointer = window.matchMedia('(pointer: fine)').matches;
            hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
        }

        const isDesktopLike = isWeb && hasHover && hasFinePointer;
        const isTouchAvailable = isNative || hasCoarsePointer || !hasHover;

        setWindowData({
            isMobile: breakPointData?.device?.isMobile || false,
            isMobileOrTablet: breakPointData?.device?.isMobile || breakPointData?.device?.isTablet || false,
            isTablet: breakPointData?.device?.isTablet || false,
            isDesktop: breakPointData?.device?.isDesktop || false,
            isNative: breakPointData?.device?.isNative || false,
            isDesktopLike: isDesktopLike,
            isTouchAvailable: isTouchAvailable,
            dimensions: dimensions,
            group: breakPointData?.group || null,
        });
    }, [breakPointData, dimensions]);

    return null;
}